module.exports = __webpack_public_path__ + "static/media/highheel.3d0cef71.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/highheel.png
// module id = 51
// module chunks = 0